import AuthInfo from '../models/auth-info';
import EdudoResponse from '../models/edudo-response';
import HttpService from './http-service';

class LoginService {
  async authenticate(email: string, password: string): Promise<AuthInfo> {
    const params = {
      email: email,
      password: password,
      grantType: 'Password'
    };

    const response = await HttpService.postJson<EdudoResponse<AuthInfo>>('/v1/authentication/login', params);

    return this.generateAuthInfo(response);
  }

  // Fire-and-forget, errors ignored: logging out must neither wait on the network nor fail when the API is
  // down or predates the route. keepalive lets the request outlive a page unload. The API answers 204
  // whatever it gets, and ends every session the token belongs to.
  logout(refreshToken: string): void {
    if (!refreshToken) {
      return;
    }

    fetch(HttpService.baseUrl.concat('/v1/authentication/logout'), {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
    }).catch(() => {});
  }

  generateAuthInfo(apiResponse: EdudoResponse<AuthInfo>): AuthInfo {
    const authInfo: AuthInfo = Object.assign(new AuthInfo(), apiResponse.data);
    authInfo.calculateExpirationDate();

    return authInfo;
  }
}

export default LoginService;